import styled from 'styled-components';

export const InputContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;

  .editableContent {
    padding: 10px 12px 20px 16px;
    border: 1px solid #d8dae5;
    border-bottom-color: transparent;
    border-radius: 8px 8px 0px 0px;
    width: 100%;
    resize: none;
    height: 54px;
    max-height: 87px;
    overflow-y: auto;
    margin-bottom: 30px;

    font-size: 14px;
    font-weight: 400;
    color: #7380c0;

    p,
    ul,
    ol {
      margin-bottom: 0;
    }

    em,
    u,
    strong,
    p,
    a {
      font-size: 14px;
    }
    ul,
    ol {
      margin-left: 20px;
    }

    .ProseMirror {
      cursor: text;
    }

    .ProseMirror p.is-editor-empty:first-child::before {
      content: attr(data-placeholder);
      color: #8f95b2;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      width: 0;
      white-space: nowrap;
      display: inline-block;
    }

    overflow-y: auto;
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 24px;
      height: 18px;
      position: fixed;
    }
    ::-webkit-scrollbar-thumb {
      height: 6px;
      border: 8px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      border-radius: 12px;
      background-color: rgba(0, 0, 0, 0.1);
    }
    ::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;

export const Disabled = styled.div`
  background: #edeff4;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
`;

export const InputBottom = styled.div`
  background: #edeff4;
  position: absolute;
  bottom: 1px;
  left: 0;
  right: 0;
  border-radius: 0px 0px 7px 7px;
  display: flex;
  align-items: center;
  padding: 2px 7px;
  border: 1px solid #d8dae5;
  border-top-color: transparent;
  border-radius: 0px 0px 7px 7px;
`;

export const InputIcon = styled.button`
  & + & {
    margin-left: 16px;
  }

  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  padding: 5px;

  span {
    display: inline-flex;
  }

  &[data-istextformatcommandactive='true'] {
    background-color: rgba(143, 149, 178, 0.4);
    border-radius: 2px;
  }
`;

export const Separator = styled.div`
  margin: 0 16px;
  background: #d6dcfa;
  width: 1px;
  height: 16px;
`;

export const SeparatorInvisible = styled.div`
  flex: 1;
`;

export const LinkPromptWrapper = styled.div`
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  position: fixed;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px;
  min-width: 50%;
  background-color: #fff;
`;

export const LinkPromptHeading = styled.h3`
  margin: unset;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #1b203a;
`;

export const LinkPromptActions = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 15px;
  justify-content: space-between;
`;

export const LinkPromptActionButton = styled.button`
  padding: 10px 16px;
  border-radius: 8px;
  flex: 1;
  border: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  background-color: #edeff4;
  color: #474d66;

  :nth-child(1) {
    background: #1371fe;
    color: #ffffff;

    :hover {
      background-color: rgba(19, 113, 254, 0.8);
    }
  }
`;

export const OpenLinkPrompt = styled.input`
  width: 100%;
  padding: 10px 16px;
  border: none;
  outline: none;
  border: 1px solid #d8dae5;
  border-radius: 8px;
`;
